<template>
  <v-form @submit.prevent="onSubmit" ref="form">
    <slot></slot>
  </v-form>
</template>
<script>
import get from "lodash/get";
import set from "lodash/set";

import Errors from "./errors";

const errorMessageMap = {
  "validation.required": "Required",
  "validation.string": "Must be a valid string",
};

export default {
  props: {
    fields: { default: () => ({}), type: Object },
    method: { default: "post" },
    action: { required: false },
    loading: { default: false, type: Boolean },
  },
  provide() {
    return {
      updateFieldValue: this.updateFieldValue,
      getFieldValue: this.getFieldValue,
      registerInput: this.registerInput,
      registerButton: this.registerButton,
      resetForm: this.resetForm,
    };
  },
  data() {
    return {
      currentFields: this.fields,
      formFields: this.fields,
      inputs: {},
      button: null,
      errors: new Errors(),
    };
  },

  methods: {
    resetForm() {
      this.$refs.form.reset();
    },
    onSubmit() {
      if (this.action) {
        this.updateButtonLoadingState(true);
        this.$emit("update:loading", true);
        this.errors.clear();
        return this.$http[this.method](this.action, this.formFields)
          .then((data) => {
            if (this.method === "post") {
              this.$refs.form.reset();
            }

            this.$emit("submitted", data);
          })
          .catch(({ response }) => {
            const errors = get(response, "data.errors");
            this.updateInputsErrors(errors);
            this.$emit("on-error", response);
            window.Notify.warning(
              get(response, "data.error", get(response.data, "message", "Something went wrong")),
            );
          })
          .finally(() => {
            this.$emit("update:loading", false);
            this.updateButtonLoadingState(false);
            // clear the fields
          });
      }
    },
    updateInputsErrors(errors) {
      this.errors.set(errors);
      this.errors.keys().forEach((name) => {
        const allErrors = this.errors.all(name) || [];

        // Try to find a friendly message
        const humanMessage =
          allErrors.find(e => !e.startsWith("validation.")) ||
          errorMessageMap[allErrors[0]] ||
          allErrors[0];

        this.updateInputErrors(name, humanMessage);

      });
    },
    updateInputErrors(name, errors) {
      if (!this.inputs[name]) {
        return;
      }
      this.inputs[name].updateError(errors);
    },

    updateFieldValue(name, value) {
      this.$emit(`input:${name}`, value);
      this.formFields = set(this.formFields, name, value);
      this.errors.clear(name);
      this.updateInputErrors(name, null);
    },

    registerInput(input) {
      this.inputs[input.name] = input;
    },
    registerButton(button) {
      this.button = button;
    },
    updateButtonLoadingState(value) {
      if (!this.button) {
        return;
      }
      this.$set(this.button.$data, "loading", value);
    },

    getFieldValue(name) {
      return get(this.currentFields, name, null);
    },
  },
};
</script>
